import { ConfirmForgotPasswordForm } from '@/components/auth/confirm-forgot-password-form';
import { ForgotPasswordForm } from '@/components/auth/forgot-password-form';
import { KaajaLogo } from '@/components/common/kaaja-logo';
import { Box, Stack } from 'TBM/OldSharedUI';
import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';
import { useRouter } from 'next/router';
import i18nConfig from '../../next-i18next.config';

export default function Page() {
  const router = useRouter();

  return (
    <Stack
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bg="neutral50"
    >
      <Box
        maxWidth="30rem"
        width="100%"
        bg="white"
        my={6}
        p={6}
        borderRadius="4px"
      >
        <Link href="/" passHref>
          <Box as="a" textAlign="center">
            <KaajaLogo />
          </Box>
        </Link>

        {router.query.isOtp ? (
          <ConfirmForgotPasswordForm />
        ) : (
          <ForgotPasswordForm />
        )}
      </Box>
    </Stack>
  );
}

export async function getStaticProps({ locale = 'it' }: GetStaticPropsContext) {
  const i18n = await serverSideTranslations(
    locale,
    ['forgot-password'],
    i18nConfig
  );

  return {
    props: { ...i18n },
  };
}
